<template>
  <v-dialog width="600" v-model="dialog" @click:outside="closeDialog()">
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between" style="width :100%">
          <h3>Chỉnh sửa công nợ</h3>
          <div class="close-btn" @click="() => closeDialog()">
            <v-icon>
              mdi-close
            </v-icon>
          </div>
        </div>
      </v-card-title>
      <v-divider class="mb-4 mt-2" />
      <v-card-text>
        <h3>{{ 'Công nợ được tính từ' }}</h3>
        <v-radio-group v-model="autoConfig" column hide-details="">
          <v-radio label="Tại thời điểm xuất hóa đơn" value="byReleaseDate" class="mb-2"></v-radio>
          <v-radio label="Tại thời điểm nhận đủ hàng" value="byCompleteDate"></v-radio>
          <v-radio label="Tuỳ chỉnh (Ngày tự tính)" value="byCustomDate"></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-divider class="mb-2" />
      <v-card-actions>
        <v-btn class="mb-2" color="primary" outlined @click="() => closeDialog()">Huỷ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="onSave">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash'
import { mapActions } from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      autoConfig: 'byReleaseDate'
    }
  },
  methods: {
    ...mapActions({
      update: 'debtConfig/updateItemImmediately'
    }),
    refresh() {
      this.autoConfig = null
    },
    closeDialog() {
      this.dialog = false
      this.refresh()
    },
    openDialog() {
      this.dialog = true
    },
    async onSave() {
      try {
        await this.update({ id: this.item.id, autoConfig: this.autoConfig })
        this.$emit('onRefresh')
        this.$alert.success('Cập nhập công nợ thành công')
        this.dialog = false
      } catch (error) {
        this.dialog = false
        this.$alert.error('Có lỗi xảy ra trong quá trình cập nhập')
      }
    }
  },
  watch: {
    item: {
      handler(val) {
        if (val && val.id) {
          this.autoConfig = get(val, 'autoConfig', 'byReleaseDate')
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.close-btn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.12);
  }
}
</style>
